/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_Src_3_DetailInputs */

const en_wb_support_src_3_detail = /** @type {(inputs: Wb_Support_Src_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration · 45 minutes`)
};

const lv_wb_support_src_3_detail = /** @type {(inputs: Wb_Support_Src_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilgums · 45 minūtes`)
};

/**
* | output |
* | --- |
* | "Duration · 45 minutes" |
*
* @param {Wb_Support_Src_3_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_src_3_detail = /** @type {((inputs?: Wb_Support_Src_3_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_Src_3_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_src_3_detail(inputs)
	return en_wb_support_src_3_detail(inputs)
});